import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../http/error-handler';

/**
 * App-wide react-query defaults. A fresh client is created per browser session
 * in QueryProvider; this factory keeps the config in one place.
 *
 * We do NOT retry user errors (4xx) — retrying a 403 or a validation failure
 * just delays the inevitable. Transient faults (network / 5xx) get two tries.
 */
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
